import { net_filemanage } from "@/api/http";

export const API_STFMFM02C09_FilePreviewDisplay = (...params) =>
net_filemanage.post("/api/STFMFM02C09/FilePreviewDisplay", ...params);

export const API_STFMFM02C09_DownloadFile = (...params) =>
net_filemanage.post("/api/STFMFM02C09/DownloadFile", ...params);

export const API_STFMFM02C09_CheckFileStatus = (...params) =>
net_filemanage.post("/api/STFMFM02C09/CheckFileStatus", ...params);

export const API_STFMFM02C09_UnlockFile = (...params) =>
net_filemanage.post("/api/STFMFM02C09/UnlockFile", ...params);


// No4スキャナ保存対応
export const API_STFMFM02C09_RequirementCheck = (...params) =>
net_filemanage.post("/api/STFMFM02C09/RequirementCheck", ...params);